import type { ComponentProps, Ref } from 'react';
import { Fragment } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export type DocumentProps = ComponentProps<'article'>;

export function Document({ className, ...props }: DocumentProps) {
  return <article className={cx('doc', className)} {...props} />;
}

export type DocumentTitleProps = ComponentProps<'h3'>;

export function DocumentTitle({ className, ...props }: DocumentTitleProps) {
  return <h3 className={cx('doc-page-title', className)} {...props} />;
}

export type DocumentSubtitleProps = ComponentProps<'p'>;

export function DocumentSubtitle({ className, ...props }: DocumentSubtitleProps) {
  return <p className={cx('doc-page-subtitle', className)} {...props} />;
}

export type DocumentSectionProps = ComponentProps<'div'>;

export function DocumentSection({ className, ...props }: DocumentSectionProps) {
  return <div className={cx('doc-section', className)} {...props} />;
}

export interface DocumentField {
  term: ReactNode;
  value: ReactNode;
  mono?: boolean;
}

export interface DocumentFieldsProps extends Omit<HTMLAttributes<HTMLDListElement>, 'children'> {
  fields: readonly DocumentField[];
}

export function DocumentFields(
  { ref, fields, className, ...rest }: DocumentFieldsProps & { ref?: Ref<HTMLDListElement> },
) {
  return (
    <dl ref={ref} className={cx('doc-fields', className)} {...rest}>
      {fields.map((field, i) => (
        <Fragment key={i}>
          <dt>{field.term}</dt>
          <dd className={cx(field.mono && 'mono')}>{field.value}</dd>
        </Fragment>
      ))}
    </dl>
  );
}
